<template>
<v-container fluid>
  <v-row no-gutters>
    <v-col cols="12">
      <v-card>
        <v-card-title>作業日報出張編集</v-card-title>
        <!-- 工事情報 -->
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="4">
              <v-text-field label="作業日" v-model="constructionDate" prepend-inner-icon="mdi-calendar-month" dense outlined readonly/>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-text-field label="工事名" v-model="tabData.constructionName" prepend-inner-icon="mdi-message-settings-variant-outline" dense outlined readonly/>
            </v-col>
            <v-col cols="12" md="4">
              <v-select label="工種" v-model="tabData.constructionType" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.constructionTypeList" item-text="name" item-value="value" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
            <v-col cols="12" md="4" v-if="!workAreaDivision">
              <v-select label="作業項目" v-model="tabData.workItem" prepend-inner-icon="mdi-format-list-bulleted-triangle"
              :items="tabData.workItemList" item-text="name" item-value="value" :disabled="tabData.constructionType == null" no-data-text="データがありません" dense outlined readonly>
              </v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <!-- 入力フォーム -->
        <v-form ref="tab_form" v-model="tabValid" @submit.prevent>
          <v-container fluid>
            <div>
              <v-toolbar color="accent" dark flat dense><v-toolbar-title>出張情報</v-toolbar-title></v-toolbar>
              <v-row><v-col cols="12"><header>出張情報</header></v-col></v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field v-model="tabData.businessTrip" label="出張先" prepend-inner-icon="mdi-bus" dense outlined></v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-checkbox v-model="tabData.stay" label="宿泊あり" dense></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <header>移動方法</header>
                  <v-radio-group v-model="tabData.move" row>
                    <v-radio :label="moveWay.nothing.name" :value="moveWay.nothing.id"></v-radio>
                    <v-radio :label="moveWay.airplane.name" :value="moveWay.airplane.id"></v-radio>
                    <v-radio :label="moveWay.jr.name" :value="moveWay.jr.id"></v-radio>
                    <v-radio :label="moveWay.car.name" :value="moveWay.car.id"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <header>高速道路(ETC)</header>
                  <v-checkbox v-model="tabData.etc" label="使用あり" dense></v-checkbox>
                </v-col>
              </v-row>
              <v-row><v-col cols="12"><header>備考</header></v-col></v-row>
              <v-row>
                <v-col cols="12">
                  <v-textarea v-model="tabData.remark" label="備考" rows="5" prepend-inner-icon="mdi-comment-processing-outline" outlined></v-textarea>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-form>
        <!-- アクション -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn depressed color="grey lighten-1" :to="{ name: returnViewName, params: { worker_date: prmWorkerDate, user_id: prmUserId, construction_key: this.prmConstructionKey } }" :disabled="!returnViewName">戻る</v-btn>
          <v-btn depressed color="primary" @click.prevent="confirmationDialogDrawer=!confirmationDialogDrawer" :disabled="!tabValid">確認</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>

  <!-- 作業日報確認ダイアログ -->
  <v-row justify="center">
    <v-dialog v-model="confirmationDialogDrawer" persistent max-width="700px">
      <v-card>
        <v-card-title><span class="headline">作業日報確認</span></v-card-title>
        <v-card-text>
          <v-toolbar color="accent" dark flat dense><v-toolbar-title>{{ tabData.tabName }}</v-toolbar-title></v-toolbar>
          <v-row v-if="tabData.constructionType != null">
            <v-col cols="4"><header>工種</header></v-col>
            <v-col cols="8"><header>{{ tabData.constructionType.name }}</header></v-col>
          </v-row>
          <v-divider/>
          <v-row v-if="(tabData.workItem != null) && !workAreaDivision">
            <v-col cols="4"><header>作業項目</header></v-col>
            <v-col cols="8"><header>{{ tabData.workItem.name }}</header></v-col>
          </v-row>
          <v-divider/>
          <!-- 出張情報 -->
          <v-row v-if="tabData.businessTrip != ''">
            <v-col cols="4"><header>出張先</header></v-col>
            <v-col cols="8"><header>{{ tabData.businessTrip }}</header></v-col>
          </v-row>
          <v-divider v-if="tabData.businessTrip != ''"/>
          <v-row v-if="tabData.businessTrip != ''">
            <v-col cols="4"><header>宿泊</header></v-col>
            <v-col cols="8"><header>{{ tabData.stay ? '宿泊あり' : '宿泊なし' }}</header></v-col>
          </v-row>
          <v-divider v-if="tabData.businessTrip != ''"/>
          <v-row v-if="tabData.move != moveWay.nothing.id">
            <v-col cols="4"><header>移動方法</header></v-col>
            <v-col cols="8">
              <header>
                <span v-if="tabData.move == moveWay.airplane.id">{{ moveWay.airplane.name }}</span>
                <span v-else-if="tabData.move == moveWay.jr.id">{{ moveWay.jr.name }}</span>
                <span v-else-if="tabData.move == moveWay.car.id">{{ moveWay.car.name }}</span>
              </header>
            </v-col>
          </v-row>
          <v-divider v-if="tabData.move != moveWay.nothing.id"/>
          <v-row v-if="tabData.move == moveWay.car.id">
            <v-col cols="4"><header>高速道路(ETC)</header></v-col>
            <v-col cols="8"><header>{{ tabData.etc ? '使用あり' : '使用なし' }}</header></v-col>
          </v-row>
          <v-divider v-if="tabData.move == moveWay.car.id"/>
          <v-row v-if="tabData.remark != ''">
            <v-col cols="4"><header>備考</header></v-col>
            <v-col cols="8"><header style="white-space:pre-wrap; word-wrap:break-word;">{{ tabData.remark }}</header></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey lighten-1" @click="confirmationDialogDrawer=!confirmationDialogDrawer">キャンセル</v-btn>
          <v-btn color="success" @click.prevent="submit()">保存</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</v-container>
</template>

<script>
import { useAppInsights } from '@/plugins/application-insights';
import statusList from "@/helpers/const";
import WorkerDailyReportSubApi from "@/api/worker-daily-report-sub-api";
import WorkerDailyReportExpenseBulkApi from "@/api/worker-daily-report-expense-bulk-api";
export default {
  name: "WorkerDailyReportBusinessTripEdit",
  // props: ["user"],
  data: () => ({
    loading: false,
    returnViewName: "",
    // 画面引数
    prmRecordId: 0,
    prmUserId: null,
    prmWorkerDate: "",
    prmReferrer: "",
    prmConstructionKey: null,
    // ------------------------
    // 共通
    // ------------------------
    renderingKeyCount: 0,
    // 作業日
    constructionDate: "",
    // 作業項目可否
    workAreaDivision: false,
    // 格納用
    tabData: {
      tabName: null,
      constructionId: null,
      constructionNumber: null,
      constructionName: null,
      siteName: null,
      constructionTypeList: null,
      constructionType: null,
      workArea: false,
      workItemList: null,
      workItem: null,
      startWorkerTime: null,
      endWorkerTime: null,
      workerBreakHourTime: null,
      workerBreakMinuteTime: null,
      startOverTime: null,
      endOverTime: null,
      overBreakHourTime: null,
      overBreakMinuteTime: null,
      workerContent: "",
      businessTrip: "",
      stay: false,
      move: 0,
      etc: false,
      remark: null,
      priceUpdated: "",
      expenseTableDataList: null,
      expenseTableData: null,
      expenseSelectBoxList: null,
      expenseSelectBox: null,
      workerTime: null,
      overTime: null
    },
    // バリデート
    tabValid: false,

    // ------------------------
    // 出張情報
    // ------------------------
    // 移動方法
    moveWay: {
      nothing: {name: "なし", id: 0},
      airplane: {name: "飛行機", id: 1},
      jr: {name: "JR", id: 2},
      car: {name: "社用車/自家用車", id: 3}
    },

    // ------------------------
    // 作業報告確認ダイアログ
    // ------------------------
    confirmationDialogDrawer: false,
    confirmationSelectTab: null,
  }),
  created() {
    this.initialize();
  },
  watch: {
    tabValid() {
      this.tabValid = true
      for(var input of this.$refs.tab_form.inputs) {
        if (!input.valid) {
          this.tabValid = false
          break;
        }
      }
    }
  },
  methods: {
    // ------------------------
    // 初期化処理
    // ------------------------
    initialize() {
      this.isLoading();
      // 画面引数をセット
      this.prmRecordId = this.$route.params.id;
      this.prmUserId = this.$route.params.user_id;
      this.prmWorkerDate = this.$route.params.worker_date;
      this.prmReferrer = this.$route.params.referrer;
      this.prmConstructionKey = this.$route.params.construction_key;
      this.constructionDate = this.prmWorkerDate;
      // 遷移元画面に応じたパンくずリストの設定
      let breadcrumbs = [];
      if (this.prmReferrer == 'store') {
        // 作業日報作成画面から遷移
        this.returnViewName = 'WorkerDailyReportStore';
        const toStoreView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId
          }
        };
        breadcrumbs = [
          { text: "ダッシュボード", disabled: false, href: "/dashboard" },
          { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
          { text: "作業日報作成", disabled: false, href: null, to: toStoreView },
          { text: "作業日報出張編集", disabled: true }
        ];
      }
      if (this.prmReferrer == 'edit') {
        // 作業日報編集画面から遷移
        this.returnViewName = 'WorkerDailyReportEdit';
        const toEditView = {
          name: this.returnViewName,
          params: {
            worker_date: this.prmWorkerDate,
            user_id: this.prmUserId,
            construction_key: this.prmConstructionKey
          }
        };
        const toConstructionView = {
          name: "ConstructionDailyReportEdit",
          params: this.prmConstructionKey
        };
        if (!this.prmConstructionKey) {
          breadcrumbs = [
            { text: "ダッシュボード", disabled: false, href: "/dashboard" },
            { text: "作業日報一覧", disabled: false, href: "/report/daily/worker" },
            { text: "作業日報編集", disabled: false, href: null, to: toEditView },
            { text: "作業日報出張編集", disabled: true }
          ];
        } else {
          // 工事日報画面経由の作業日報編集画面から遷移
          breadcrumbs = [
            { text: "ダッシュボード", disabled: false, href: "/dashboard" },
            { text: "工事日報一覧", disabled: false, href: "/report/daily/construction" },
            { text: "工事日報再集計", disabled: false, href: null, to: toConstructionView },
            { text: "作業日報編集", disabled: false, href: null, to: toEditView },
            { text: "作業日報出張編集", disabled: true }
          ];
        }
      }
      if (breadcrumbs) {
        this.$route.meta.breadcrumbs = breadcrumbs;
        this.$emit('updatebc');
      }
      // 作業日報を取得
      this.WorkerDailyReportSubApi = new WorkerDailyReportSubApi();
      this.workerDailyReportExpenseBulkApi = new WorkerDailyReportExpenseBulkApi();
      const promise = this.workerDailyReportExpenseBulkApi.info(this.prmRecordId);
      promise.then((response) => {
        // 日報情報をセット
        this.tabData = response.data.body.worker_daily_report_info.report;
        this.workAreaDivision = this.tabData.workArea;
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else if (error.response.data.status == statusList.status.entityError) {
            this.$emit("error", error.response.data.message);
            this.$router.push({ name: this.returnViewName, params: { worker_date: this.prmWorkerDate, user_id: this.prmUserId, construction_key: this.prmConstructionKey } });
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
      });
    },
    // ------------------------
    // 作業報告確認ダイアログ
    // ------------------------
    submit() {
      this.isLoading();
      const params = {
        report: JSON.stringify(this.tabData)
      };
      const promise = this.WorkerDailyReportSubApi.update(this.prmRecordId, { params: params });
      promise.then((response) => {
        this.$emit('success', response.data.message);
      }).catch(error => {
        useAppInsights().trackException({exception: error});
        if (error.response) {
          if (error.response.data.status == statusList.status.authError) {
            this.$emit('logoutConform');
          } else {
            this.$emit("error", error.response.data.message);
          }
        } else {
          this.$emit("error", "サーバーエラーが発生しました。");
        }
      }).finally(() => {
        this.isLoading();
        this.$router.push({ name: this.returnViewName, params: { worker_date: this.prmWorkerDate, user_id: this.prmUserId, construction_key: this.prmConstructionKey } });
      });
    },
    // ------------------------
    // その他処理
    // ------------------------
    // ローディング表示・非表示
    isLoading() {
      this.loading = !this.loading;
      this.$emit("loading", this.loading);
    },
  }
}
</script>
